import React, { useEffect, useRef, useState } from "react";
import { BASE_URL, API_KEY } from "./config";
import "./FeedbackModal.css";

const FeedbackModal = ({ onClose, sourcePage }) => {
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const dialogRef = useRef(null);
  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialogRef.current?.querySelector('input')?.focus();
    const handleKey = event => {
      if (event.key === 'Escape') { event.preventDefault(); onClose(); }
      if (event.key !== 'Tab') return;
      const controls = dialogRef.current?.querySelectorAll('button:not(:disabled), input:not(:disabled), textarea:not(:disabled)');
      if (!controls?.length) return;
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleKey);
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, [onClose]);

  const submitFeedback = async (event) => {
    event.preventDefault();
    if (busy || sent) return;
    if (!message.trim()) { setError("Please enter a message."); return; }
    setBusy(true);
    setError("");
    try {
      const response = await fetch(`${BASE_URL}/api/bot/ui/feedback/public`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-SIGNALFLY-KEY": API_KEY },
        body: JSON.stringify({ email: email.trim(), message: message.trim(), sourcePage }),
      });
      if (!response.ok) throw new Error("Feedback request failed");
      setSent(true);
    } catch {
      setError("Your message could not be sent. Please try again.");
    } finally { setBusy(false); }
  };

  return (
    <div className="feedback-modal-overlay">
      <form ref={dialogRef} className="feedback-modal-content" onSubmit={submitFeedback} role="dialog" aria-modal="true" aria-labelledby="feedback-title">
        <div className="feedback-modal-header">
          <div>
            <span className="feedback-eyebrow">SignalFly Feedback</span>
            <h3 id="feedback-title">Contact SignalFly</h3>
            <p>Tell us what should be clearer, faster, or easier in your trading workflow.</p>
          </div>
          <button className="feedback-close-btn" onClick={onClose} type="button" aria-label="Close contact form">
            X
          </button>
        </div>

        {error && <p className="auth-error" role="alert">{error}</p>}
        {sent && <p className="auth-success" role="status">Thanks. Your message has been sent.</p>}
        <div className="feedback-field-grid">
          <label>
            <span>Email optional</span>
            <input
              type="email" disabled={busy || sent}
              placeholder="name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <label>
            <span>Feedback</span>
            <textarea required disabled={busy || sent}
              placeholder="Feature idea, issue, confusing screen, missing signal detail..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </label>
        </div>

        <div className="feedback-modal-actions">
          <button className="feedback-submit-btn" type="submit" disabled={busy || sent}>{sent ? 'Message sent' : busy ? 'Sending…' : 'Send message'}</button>
          <button className="feedback-cancel-btn" type="button" onClick={onClose}>Close</button>
        </div>
      </form>
    </div>
  );
};

export default FeedbackModal;
